export default __webpack_public_path__ + "static/SCROLL_6-46ab4cef0ddca4125dcc0e2cb0c09ea7.png";